// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GbXA","col":"styles_col__jcAhj"};